module.exports = __webpack_public_path__ + "img/14order.1be04d9b.png";